const normalizeDomain = (domain: string) => {
  // Remove https:// if present
  domain = domain.replace(/^https?:\/\//, "");
  // Remove www. if present
  domain = domain.replace(/^www\./, "");
  return domain;
};

export default normalizeDomain;
